import React from 'react';
import FlexCard from '../General/FlexCard';
import {RadioGroup, Radio, Box, Heading, Stack, StackDivider} from '@chakra-ui/react';

const CriteriaCard = ({reportInfo, value, setValue, setSectionId}) => {
  return (
    <FlexCard>
      <Box>
        <Heading>{reportInfo.section}</Heading>
        {/** for some reason the value automatically turns to string, so if we want the id's to be of type int we have to convert string -> int before setting value */}
        <RadioGroup
          value={value}
          onChange={val => {
            setValue(val);
            setSectionId(reportInfo.sectionId);
          }}
        >
          <Stack>
            <StackDivider />
            {reportInfo.reports.map((report, idx) => {
              {
                /* return <CustomRadio register={register} id={report.id} key={report.id} name={report.report} />; */
              }
              return (
                <Radio colorScheme="tertiary" key={idx} value={report.promptId}>
                  {report.description}
                </Radio>
              );
            })}
          </Stack>
        </RadioGroup>
      </Box>
    </FlexCard>
  );
};

export default CriteriaCard;
